var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{name:'influencer-card',params:{id:_vm.id}}}},[_c('feather-icon',{attrs:{"icon":"InstagramIcon","size":"22"}}),_vm._v(" "+_vm._s(_vm.name)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }